'use client'

import React, { useEffect, useState } from 'react'
import DesktopNavigation from './navigation/desktop/DesktopNavigation'
import { motion, AnimatePresence } from 'framer-motion'

const Navigation = () => {
  const [showNavigation, setShowNavigation] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      if (currentScrollY >= 40) {
        setShowNavigation(false) // Verberg navigatie als je begint te scrollen
      } else {
        setShowNavigation(true) // Toon navigatie als je aan de top bent
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <AnimatePresence>
      {showNavigation && (
        <motion.header
          key="navigation"
          className="fixed top-0 left-0 w-full z-40"
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
          <DesktopNavigation />
        </motion.header>
      )}
    </AnimatePresence>
  )
}

export default Navigation
